import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

export const CustomTypography: React.FC<TypographyProps> = (props) => {
  const { fontSize = 'small', ...typographyProps } = props;
  return (
    <Typography
      {...typographyProps}
      fontSize={fontSize}
    >
      {props.children}
    </Typography>
  );
};

CustomTypography.displayName = 'CustomTypography';
